export const ageGroups = ['newborn', 'baby', 'toddler', 'preschooler']
